import styled from "styled-components";

export const DarkModeWrapper = styled.div`
  position: absolute;
  bottom: 12%;
  left: 46%;
  opacity: 0.7;
`;
